<template>
  <div class="columns is-tabled is-multiline is-centered">
    <div class="column is-one-third" v-for="item in list" :key="item.name">
      <div class="card">
        <div class="card-image">
          <figure class="image">
            <img
              :src="require(`@/assets/work/${item.image}`)"
              :alt="item.name"
            />
          </figure>
        </div>
        <div class="card-content">
          <div class="content">
            <strong>{{ item.name }}</strong>
            <br />
            {{ item.info }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from "@/data/strengths.json";
export default {
  name: "Strengths",
  data() {
    return { list };
  }
};
</script>

<style scoped lang="scss">
.card {
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  width: 320px;
  height: 100%;
  border: medium none;
  box-shadow: none;

  .image img {
    max-width: 50%;
    margin: 0 auto;
  }

  .card-content {
    padding: 0.25em 0 0.75em 0;
  }

  strong {
    font-weight: bolder;
    font-size: 16px;
  }

  .card-footer {
    margin-top: auto;
  }
}
</style>
